import { render, staticRenderFns } from "./AdminChargesRoute.vue?vue&type=template&id=35c10025"
import script from "./AdminChargesRoute.vue?vue&type=script&lang=js"
export * from "./AdminChargesRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports